
  import React from "react"
  import Component from "/opt/atlassian/pipelines/agent/build/website/src/layouts/index.jsx"
  import data from "/opt/atlassian/pipelines/agent/build/website/.cache/json/layout-index.json"

  export default (props) => <Component {...props} {...data} />
  


// WEBPACK FOOTER //
// ./.cache/layouts/index.js